import styled from 'styled-components'

import { IconCalendar } from '@avantstay/backoffice-vectors'

import { mainColors } from '../../styles/colors'
import { _XS_Normal } from '../../styles/typography'
import { zIndex } from '../../styles/zIndex'
import { rgba } from '../../utils'

export const Root = styled.div`
  position: relative;
  width: 100%;
`

export const Popover = styled.div`
  // Portaled to <body>, so it must out-stack the modal (z-index 100) it can open inside of —
  // e.g. the hotel create-booking dialog. FOLD_OUT_MENU (18) renders behind it.
  z-index: ${zIndex.FLOATING_MODAL};
  background: ${mainColors.white};
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 4px;
  box-shadow: 0 4px 16px ${rgba(mainColors.black, 0.12)};
`

// Keeps the popover the same size while availability loads so the overlay can sit on top.
export const CalendarContainer = styled.div`
  position: relative;
`

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${rgba(mainColors.white, 0.7)};
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px 12px;
  border-top: 1px solid ${mainColors.neutralLight};
`

export const Summary = styled.div`
  ${_XS_Normal};
  color: ${mainColors.neutralExtremelyDark};
  display: flex;
  align-items: center;
  gap: 6px;
`

export const OriginalRange = styled.span`
  ${_XS_Normal};
  text-decoration: line-through;
  white-space: nowrap;
  color: ${mainColors.neutralExtraDark};
`

export const ClearButton = styled.button`
  ${_XS_Normal};
  appearance: none;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${mainColors.accentMedium};
  padding: 0;
`

export const IconCalendarStyled = styled(IconCalendar)`
  color: ${mainColors.neutralExtraDark};
`
